export const locale = {
    id: 'de-AT',
    prefix: '',
    mailDomain: 'at',
};
